<template>
    <Icons.TILegalBase class="fill-current text-orange-600"></Icons.TILegalBase>
</template>

<script setup>
import Icons from '../../Icons.js';
</script>
